function perguntas () {
  return {
    array: []
  }
}

function legislacao () {
  return {
    array: []
  }
}

function createFiltroProcessos () {
  return {
    search: null,
    status: [],
    tipo: [],
    municipio: []
  }
}

function createEmptyProcessos () {
  return {
    processos: [],
    processo: {
      cadastro: {
        cadastrante: {
          pessoa: {
            email: null,
            endereco: {
              bairro: null,
              cep: null,
              complemento: null,
              logradouro: null,
              municipio: {
                id: null,
                nome: null,
                nomeEstado: null
              },
              numero: null,
              semNumero: false,
              pessoaFisica: {
                cpf: null,
                nome: null,
                nomeEstadoCivil: null,
                nomeOrgaoExpedidor: null,
                rg: null
              }
            },
            telefones: [],
            tipo: true
          }
        },
        interessado: {
          conjuge: {
            pessoaFisica: {
              cpf: null,
              nome: null,
              nomeGentilico: null,
              naturalidade: null,
              nomeOrgaoExpedidor: null,
              rg: null
            }
          },
          pessoa: {
            email: null,
            endereco: {
              bairro: null,
              cep: null,
              complemento: null,
              logradouro: null,
              municipio: {
                id: null,
                nome: null,
                nomeEstado: null
              },
              numero: null,
              semNumero: false
            },

            pessoaFisica: {
              cpf: null,
              nome: null,
              nomeEstadoCivil: null,
              nomeGentilico: null,
              nomeOrgaoExpedidor: null,
              rg: null
            },
            pessoaJuridica: null,
            telefones: [],
            tipo: true
          }
        },
        imovel: {
          area: 0,
          descricaoAcesso: null,
          municipio: {
            id: null,
            nome: null,
            nomeEstado: null
          },
          nome: null,
          numeroReciboCar: null,
          possuiCar: true
        }
      }
    }
  }
}

const state = {
  emptyProcessos: createEmptyProcessos,
  emptyPerguntas: perguntas,
  emptyLegislacao: legislacao,
  emptyFiltroProcessos: createFiltroProcessos
}

export default {
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/empty.js